// extracted by mini-css-extract-plugin
module.exports = {"SectionBanner":"ToursView_SectionBanner__26t9S","Tours":"ToursView_Tours__39Pkz","CallToAction":"ToursView_CallToAction__VPpch","Action":"ToursView_Action__3uH6E"};